import { createSignal, Show } from 'solid-js';
import { useNavigate, useSearchParams } from '@solidjs/router';
import { authStore } from '../lib/auth-store.js';

export default function Login() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [username, setUsername] = createSignal('');
  const [password, setPassword] = createSignal('');
  const [loading, setLoading]   = createSignal(false);
  const [error, setError]       = createSignal('');

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await authStore.login(username().trim(), password());
      const next = params.next || '/';
      navigate(decodeURIComponent(next), { replace: true });
    } catch (err) {
      setError(err.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div class="login-wrap">
      <form class="login-card" onSubmit={submit}>
        <div class="logo" style="margin-bottom: 18px;">
          <span class="logo-mark" />
          <span>Ninocat</span>
        </div>
        <h1>Sign in</h1>
        <p class="sub">Internal MySQL workspace.</p>

        <div class="field">
          <label class="label" for="username">Username</label>
          <input
            id="username"
            class="input"
            type="text"
            autocomplete="username"
            autofocus
            value={username()}
            onInput={(e) => setUsername(e.currentTarget.value)}
            required
          />
        </div>
        <div class="field">
          <label class="label" for="password">Password</label>
          <input
            id="password"
            class="input"
            type="password"
            autocomplete="current-password"
            value={password()}
            onInput={(e) => setPassword(e.currentTarget.value)}
            required
          />
        </div>

        <Show when={error()}>
          <div class="error-text">{error()}</div>
        </Show>

        <div style="margin-top: 14px;">
          <button class="btn" type="submit" disabled={loading()}>
            {loading() ? 'Signing in…' : 'Sign in'}
          </button>
        </div>
      </form>
    </div>
  );
}
